import TreeIcon from "~icons/local/tree";
import { NavLink, useParams } from "react-router";
import { getUrl } from "../useToPage";
import classNames from "classnames";

export default function Overview() {
  const { teamSlug, rfqId } = useParams();
  return (
    <NavLink
      to={getUrl("rfq", { teamSlug: teamSlug!, rfqId: rfqId! })}
      end
      className={({ isActive }) =>
        classNames("flex items-center gap-2 hover:bg-blue-100 p-1 rounded-sm", {
          "bg-blue-200": isActive,
        })
      }
    >
      <TreeIcon />
      Overview
    </NavLink>
  );
}
